// Lib
import React from 'react';

// Components
import PopupPanel from '../../components/popupPanel/PopupPanel';
import MobileSwitchCanvasView from '../header/workspaceToolsHeader/account/MobileSwitchCanvasView';

// Styles
import './MobileGuestSettingsPopup.scss';
import { PopupIds } from '../../components/popupPanel/popupConstants';

const MobileGuestSettingsPopup = () => (
    <PopupPanel className="MobileGuestSettingsPopup" popupId={PopupIds.GUEST_SETTINGS}>
        <MobileSwitchCanvasView />
    </PopupPanel>
);

export default MobileGuestSettingsPopup;
